export default function calculator() {
    return {
        object: '',
        prepare: '',
        coating: '',
        area: 0,
        objectLabels: {
            metal: 'Металлоконструкция',
            reservoir: 'Резервуар',
            facade: 'Фасад',
            cable: 'Кабель',
            crane: 'Кран',
            tower: 'Вышка',
            pipeline: 'Трубопровод',
            chimney: 'Дымовая труба',
        },

        prepareLabels: {
            abrasive: 'Абразивоструйная зачистка',
            hydro: 'Гидроструйная зачистка',
            mechanical: 'Механическая зачистка',
            manual: 'Ручная зачистка',
            chemical: 'Хим. смывка',
            rust: 'Очистка от ржавчины',
            concrete: 'Очистка от бетона',
            oil: 'Очистка от масел',
            none: 'Очистка не требуется',
        },

        coatingLabels: {
            anticorrosion: 'Антикоррозийное',
            fireproof: 'Огнезащитное',
            heat_resistant: 'Термостойкое',
            antistatic: 'Антистатическое',
            primer: 'Грунтовка',
            paint: 'Краска / Эмаль',
        },
        prices: {
            prepare: {
                abrasive: [3500,3200,3100,3000,2900],
                hydro: [1200,1000,900,800,700],
                mechanical: [800,750,700,600,500],
                manual: [800,750,700,600,500],
                chemical: [950,850,750,650,550],
                rust: [1200,1000,900,700,600],
                concrete: [800,700,650,550,450],
                oil: [800,700,650,550,450],
                none: [0,0,0,0,0],
            },
            coating: {
                anticorrosion: [800,750,700,600,550],
                fireproof: [1100,1000,900,800,750],
                heat_resistant: [800,750,700,600,550],
                antistatic: [800,750,700,600,550],
                primer: [350,300,250,200,170],
                paint: [500,450,400,400,370],
            }
        },

        isReady() {
            return this.prepare && this.coating && this.area > 0
        },

        areaIndex() {
            if (this.area >= 50000) return 4
            if (this.area >= 20000) return 3
            if (this.area >= 10000) return 2
            if (this.area >= 5000)  return 1
            return 0
        },

        meterPrice() {
            if (!this.prepare || !this.coating) return 0

            const i = this.areaIndex()

            return (
                this.prices.prepare[this.prepare][i] +
                this.prices.coating[this.coating][i]
            )
        },

        totalPrice() {
            return this.meterPrice() * this.area
        },

        format(n) {
            return new Intl.NumberFormat('ru-RU').format(n)
        }
    }
}
